import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

// Initial state
const state = {};

export default {
	namespaced: true, // Enable namespacing to avoid conflicts
	state,
	actions,
	mutations,
	getters
};
